module.exports = __webpack_public_path__ + "media/images/png/alert-eb16c7391b0df84610dba477e0259a20.png";